<template>
  <div id="app" :class="state.system.isOffline ? 'offline-mode' : null">
    <div ref="err" class="err"></div>
    <router-view>
      <dashboard />
    </router-view>
  </div>
</template>

<script>
import Dashboard from "./views/Dashboard";
import { mapState } from "vuex";
// import '../node_modules/bootstrap/scss/bootstrap.scss';
// import "@/styles/style.scss";
export default {
  components: {
    Dashboard,
  },
  data() {
    return {
      isSessionOpen: false,
      changeData: customData,
    };
  },
  errorCaptured(err) {
    this.$ref.err.innerHTML = "we have error ";
    console.log(err);
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
  },
  mounted() {
    this.changeTheme();
    // Check Offline
    // this.$parent.cool.then
    // console.log(this.$parent.cool);
    // console.log(this.$offlineDb);
    // let key = 'cool';
    // this.$offlineDb.getItem(key).then(function(readValue) {
    //   console.log('Read: ', readValue);
    // });
    if (this.isOnline) {
      console.log("[Online] : Zwing Cloud POS");
    } else {
      console.log("[Offline] : Zwing Cloud POS");
    }

    // if (!('indexedDB' in window)) {
    //   console.log('This browser doesn\'t support IndexedDB');
    //   return;
    // } else {
    //   console.log('Offline Supported');
    // }
  },
  watch: {
    changeData: {
      handler(val) {
        console.log("In Data");
        if (val.data.status == "device_info") {
          this.$store.commit("saveDeviceInfo", val.data.type);
        }
      },
      deep: true,
    },
  },
  methods: {
    changeTheme() {
      let themeClass = this.state.system.theme;
      let bodyClass = document.querySelector("body");
      if (themeClass == "theme-light") {
        bodyClass.classList.add("theme-light");
        bodyClass.classList.remove("theme-dark");
      }
      if (themeClass == "theme-dark") {
        bodyClass.classList.add("theme-dark");
        bodyClass.classList.remove("theme-light");
      }
    },
  },
};
</script>
//
<style lang="scss" scoped>
// .overlay {
//   background: rgba(8, 8, 8, 0.5);
//   height: 100%;
//   width: 100%;
//   position: absolute;
//   z-index: 999;
//   left: 0;
//   top: 0;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }
// .lds-ripple {
//   display: inline-block;
//   position: relative;
//   width: 64px;
//   height: 64px;
// }
// .lds-ripple div {
//   position: absolute;
//   border: 4px solid #fff;
//   opacity: 1;
//   border-radius: 50%;
//   animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
// }
// .lds-ripple div:nth-child(2) {
//   animation-delay: -0.5s;
// }
// @keyframes lds-ripple {
//   0% {
//     top: 28px;
//     left: 28px;
//     width: 0;
//     height: 0;
//     opacity: 1;
//   }
//   100% {
//     top: -1px;
//     left: -1px;
//     width: 58px;
//     height: 58px;
//     opacity: 0;
//   }
// }
//
</style>
